<template>
  <div :class="[
      'w-screen h-screen overflow-auto',
      isAdmin 
        ? 'bg-gradient-to-b from-slate-50 from-60% to-amber-100 to-90%' 
        : 'bg-gradient-to-b from-slate-50 from-60% to-slate-100 to-90%'
    ]">
      <div class="container mx-auto wrapper max-w-5xl">
          <slot></slot>
      </div>
  </div>
</template>
<script>
export default {
  computed: {
    isAdmin() {
      return this.$store.state.Role === 'admin';
    }
  }
};
</script>